import { otherRouter, appRouter } from "@/router/router";
import Util from "@/libs/util";
import Vue from "vue";

let initState = {
  requests: [],
  projectId: Number(localStorage.getItem("projectId")),
  projectTitle: localStorage.getItem("projectTitle") || '无',
  cachePage: [],
  lang: "test",
  backConfirm: true,
  isFullScreen: false,
  openedSubmenuArr: [], // 要展开的菜单数组
  menuTheme: "dark", // 主题
  themeColor: "",
  pageOpenedList: [
    {
      title: "首页",
      path: "/view/home",
      name: "home"
    }
  ],
  currentPageName: "",
  currentPath: [
    {
      title: "首页",
      path: "/view/home",
      name: "home"
    }
  ], // 面包屑数组
  menuTree: JSON.parse(localStorage.getItem("menuTree")) || [],
  menuList: JSON.parse(localStorage.getItem("menuList")) || [],
  routers: [
    // otherRouter
  ],
  dontCache: ["text-editor", "artical-publish"], // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
  dropDown: [],
  sidebarFooter: JSON.parse(localStorage.getItem('sidebarFooter')) || [],
  bookmarkInfo: {}
};

const app = {
  state: initState,
  mutations: {
    RESET_app(state) {
      state = Object.assign(state, initState);
      appRouter.children = [];
    },
    SET_REQUESTS(state, requests) {
      state.requests = requests;
    },
    SET_MENU_TREE(state, list) {
      state.menuTree = list;
      localStorage.setItem("menuTree", JSON.stringify(list))
    },
    SET_MENU_LIST(state, list) {
      // console.log(list, "菜单列表list");
      state.menuList = list;
      localStorage.setItem("menuList", JSON.stringify(list))
    },
    SET_OTHER_LIST(state, list) {
      state.dropDown = list.filter(item => item.type === "DropDown");
      state.sidebarFooter = list.filter(item => item.type === "SidebarFotter");
      localStorage.setItem('sidebarFooter', JSON.stringify(state.sidebarFooter))
      Util.setOtherRouter(list, otherRouter);
    },
    UPDATE_ROUTERS(state, menulist) {
      menulist.length && Util.setAppRouter(menulist, appRouter);
    },
    SET_PROJECT_ID(state, id) {
      state.projectId = Number(id);
      localStorage.setItem('projectId', Number(id))
    },
    SET_PROJECT_TITLE(state, title) {
      state.projectTitle = title;
      localStorage.setItem("projectTitle", title)
    },
    SET_BOOKMARK_INFO(state, info) {
      // console.log(info, "infoinfoinfo");
      state.bookmarkInfo = info;
    },
    changeMainTheme(state, mainTheme) {
      state.themeColor = mainTheme;
    },
    addOpenSubmenu(state, name) {
      let hasThisName = false;
      let isEmpty = false;
      if (name.length === 0) {
        isEmpty = true;
      }
      if (state.openedSubmenuArr.indexOf(name) > -1) {
        hasThisName = true;
      }
      if (!hasThisName && !isEmpty) {
        state.openedSubmenuArr.push(name);
      }
    },
    closePage(state, name) {
      state.cachePage.forEach((item, index) => {
        if (item === name) {
          state.cachePage.splice(index, 1);
        }
      });
    },
    initCachepage(state) {
      if (localStorage.cachePage) {
        state.cachePage = JSON.parse(localStorage.cachePage);
      }
    },
    removeTag(state, name) {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1);
        }
      });
    },
    pageOpenedList(state, get) {
      let openedPage = state.pageOpenedList[get.index];
      if (get.argu) {
        openedPage.argu = get.argu;
      }
      if (get.query) {
        openedPage.query = get.query;
      }
      state.pageOpenedList.splice(get.index, 1, openedPage);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    clearAllTags(state) {
      state.pageOpenedList.splice(1);
      state.cachePage.length = 0;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    clearOtherTags(state, vm) {
      let currentName = vm.$route.name;
      let currentIndex = 0;
      state.pageOpenedList.forEach((item, index) => {
        if (item.name === currentName) {
          currentIndex = index;
        }
      });
      if (currentIndex === 0) {
        state.pageOpenedList.splice(1);
      } else {
        state.pageOpenedList.splice(currentIndex + 1);
        state.pageOpenedList.splice(1, currentIndex - 1);
      }
      let newCachepage = state.cachePage.filter(item => {
        return item === currentName;
      });
      state.cachePage = newCachepage;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    setOpenedList(state) {
      state.pageOpenedList = localStorage.pageOpenedList
        ? JSON.parse(localStorage.pageOpenedList)
        : [otherRouter.children[0]];
    },
    setCurrentPath(state, pathArr) {
      state.currentPath = pathArr;
    },
    setCurrentPageName(state, name) {
      state.currentPageName = name;
    },
    switchLang(state, lang) {
      state.lang = lang;
      Vue.config.lang = lang;
    },
    clearOpenedSubmenu(state) {
      state.openedSubmenuArr.length = 0;
    },
    increateTag(state, tagObj) {
      if (!Util.oneOf(tagObj.name, state.dontCache)) {
        state.cachePage.push(tagObj.name);
        localStorage.cachePage = JSON.stringify(state.cachePage);
      }
      state.pageOpenedList.push(tagObj);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    }
  },
  getters: {
    hasMetadata: state => {
      return state.sidebarFooter.some(
        item => item.name === "metadata" && item.projectId === state.projectId
      );
    },
    hasBookMark: state => {
      return state.sidebarFooter.some(
        item => item.name === "bookmark" && item.projectId === state.projectId
      );
    },
    dropDownList: state => {
      return state.dropDown.filter(
        item => item.projectId === state.projectId || item.projectId === 0
      );
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js